import { Divider, Stack } from '@mantine/core';
import {
  useDeleteSignature,
  useSignatureDetails,
  useUpdateSignoffText,
  useUploadSignature,
} from '../hooks/useSignature';
import SignatureEditor from './SignatureEditor';
import TabHeader from './TabHeader';

export default function SignatureUpload() {
  const {
    downloadUrl,
    hasSignature,
    signoffText: savedSignoffText,
    refetch: refetchSignatureDetails,
  } = useSignatureDetails();
  const { uploadSignature, isLoading: isUploading } = useUploadSignature();
  const { deleteSignature, isLoading: isDeleting } = useDeleteSignature();
  const { updateSignoffText, isLoading: isSavingSignoff } = useUpdateSignoffText();

  const handleUpload = async (file: File) => {
    await uploadSignature(file);
    await refetchSignatureDetails();
  };

  return (
    <Stack>
      <TabHeader
        title="Signature"
        subtitle="Upload an image of your signature and add sign-off text. These will be used together in suitability reports and other documents."
      />

      <Divider size="xs" color="gray.2" mt="xs" />

      <SignatureEditor
        downloadUrl={downloadUrl}
        hasSignature={hasSignature}
        savedSignoffText={savedSignoffText}
        isUploading={isUploading}
        isDeleting={isDeleting}
        isSavingSignoff={isSavingSignoff}
        onUpload={handleUpload}
        onDelete={deleteSignature}
        onSaveSignoff={updateSignoffText}
      />
    </Stack>
  );
}
